import { clsx } from 'clsx';
import React, { ReactNode } from 'react';

import { BaseButton, Icon } from '@common/components';

/**
 * Legacy status pill (styled `BaseButton`).
 *
 * @deprecated Use `StatusPill` from `@common/components` for new UI instead of this component.
 */
export const DeprecatedStatePill = ({
  dropdown,
  color,
  fontSize,
  capitalized = false,
  children,
  className,
  ...other // for compatibility reasons. however, this is not typed (or rather, typed as {})
}: {
  children?: ReactNode | undefined;
  fontSize?: string;
  // TODO: fix this color prop to use ColorsType
  // example: coralHyperlight instead of coral-hyperlight
  // WORK-705
  // https://app.asana.com/1/303134204339906/project/1210244193526850/task/1210689664512026?focus=true
  color?: string;
  dropdown?: boolean;
  capitalized?: boolean;
  className?: string;
  icon?: React.ReactElement | null;
}) => (
  <>
    <BaseButton
      {...other}
      size="small"
      postIcon={dropdown ? <Icon icon="caretDown" size="sm" /> : null}
      shape="round"
      className={clsx(
        'wk-state-pill',
        `button-${color}`,
        'wk-state-pill--text-style',
        className,
        {
          'wk-state-pill--default-cursor': !dropdown,
        }
      )}
    >
      {children}
    </BaseButton>
    <style jsx>{`
      :global(.wk-state-pill.wk-state-pill--default-cursor) {
        cursor: default;
      }

      :global(.wk-state-pill.wk-state-pill--text-style) {
        font-size: ${fontSize};
        ${capitalized ? 'text-transform: capitalize;' : ''}
      }
    `}</style>
  </>
);
